export type ErrorDetails = Record<string, string[]>;

export interface StandardErrorResponse {
  status: number;
  code: string;
  message: string;
  details?: ErrorDetails | null;
  timestamp?: string;
  path?: string;
  requestId?: string | null;
}

export class ApiError extends Error {
  status: number;
  code: string;
  details?: ErrorDetails | null;
  timestamp?: string;
  path?: string;
  requestId?: string | null;

  constructor(payload: StandardErrorResponse) {
    super(payload.message || payload.code || 'API Error');
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = 'ApiError';
    this.status = payload.status;
    this.code = payload.code;
    this.details = payload.details ?? null;
    this.timestamp = payload.timestamp;
    this.path = payload.path;
    this.requestId = payload.requestId ?? null;
  }
}

export default ApiError;
